// src/categories/categoryMappings.js
const categoryMappings = {
  'Anexo 30 y 31 2022': [
    'anexo30Y31Ano2022DatosGenerales',
    'anexo30Y31Ano2022SistemasDeMedicion',
    'anexo30Y31Ano2022SGM',
    'anexo30Y31Ano2022ProgramaInformatico',
    'anexo30Y31Ano2022EvidenciasFotograficas',
  ],
  'Anexo 30 y 31 2023': [
    'anexo30Y31Ano2023DatosGenerales',
    'anexo30Y31Ano2023SistemasDeMedicion',
    'anexo30Y31Ano2023SGM',
    'anexo30Y31Ano2023ProgramaInformatico',
    'anexo30Y31Ano2023EvidenciasFotograficas',
  ],
  'Anexo 30 y 31 2024': [
    'anexo30Y31Ano2024DatosGenerales',
    'anexo30Y31Ano2024SistemasDeMedicion',
    'anexo30Y31Ano2024SGM',
    'anexo30Y31Ano2024ProgramaInformatico',
    'anexo30Y31Ano2024EvidenciasFotograficas',
    'anexo30Y31Ano2024Certificado',
  ],
  'Anexo 30 y 31 2025': [
    'anexo30Y31Ano2025DatosGenerales',
    'anexo30Y31Ano2025SistemasDeMedicion',
    'anexo30Y31Ano2025SGM',
    'anexo30Y31Ano2025ProgramaInformatico',
    'anexo30Y31Ano2025EvidenciasFotograficas',
    'anexo30Y31Ano2025Certificado',
  ],
  'Dictamen de Diseño': [
    'dictamenDeDisenoDocumentos',
    'dictamenDeDisenoPlanos',
  ],
  'NOM-016-CRE-2016': [
    'nom016InformacionGeneral',
    'nom016Documentacion',
  ],
  'Anexo 30 y 31 para transporte o distribución': [
    'inspeccion30Y31Ano2024DatosGenerales',
    'inspeccion30Y31Ano2024SistemasDeMedicion',
    'inspeccion30Y31Ano2024SGM',
    'inspeccion30Y31Ano2024ProgramaInformatico',
    'inspeccion30Y31Ano2024Politicas',
  ],
  'Anexo 21 y 22 rmf 2026': [
    'anexo21Y22Rmf2026DatosGenerales',
    'anexo21Y22Rmf2026SistemasDeMedicion',
    'anexo21Y22Rmf2026SGM',
    'anexo21Y22Rmf2026ProgramaInformatico',
    'anexo21Y22Rmf2026EvidenciasFotograficas',
    'anexo21Y22Rmf2026Certificado',
  ],
  'Transporte Anexo 21 y 22 rmf 2026': [
    'transporteAnexo21Y22Rmf2026DatosGenerales2026',
    'transporteAnexo21Y22Rmf2026SistemasDeMedicion2026',
    'transporteAnexo21Y22Rmf2026SistemasDeMedicion2026DocumentosComplementarios',
    'transporteAnexo21Y22Rmf2026SGM2026',
    'transporteAnexo21Y22Rmf2026ProgramaInformatico2026',
    'transporteAnexo21Y22Rmf2026Certificado2026',
  ],
  'Distribución Anexo 21 y 22 rmf 2026': [
    'distribucionAnexo21Y22Rmf2026DatosGenerales2026',
    'distribucionAnexo21Y22Rmf2026SistemasDeMedicion2026',
    'distribucionAnexo21Y22Rmf2026SGM2026',
    'distribucionAnexo21Y22Rmf2026ProgramaInformatico2026',
    'distribucionAnexo21Y22Rmf2026Certificado2026',
  ],
  'Comercializadora Anexo 21 y 22 rmf 2026': [
    'comercializadoraAnexo21Y22Rmf2026DatosGenerales2026',
    'comercializadoraAnexo21Y22Rmf2026ProgramaInformatico2026',
    'comercializadoraAnexo21Y22Rmf2026Certificado2026',
  ],
};

/**
 * Categorías que entran en totales de progreso (subidos / completados).
 * Excluye certificado JSON: un solo requisito y no debe mezclarse con el resto de secciones.
 */
export function categoryKeysForProgressTotals(serviceName) {
  return (categoryMappings[serviceName] || []).filter((key) => !key.includes('Certificado'));
}

export default categoryMappings;
